import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const applicationsPlugin = createPlugin({
  id: 'applications',
  routes: {
    root: rootRouteRef,
  },
});

export const ApplicationsPage = applicationsPlugin.provide(
  createRoutableExtension({
    name: 'ApplicationsPage',
    component: () =>
      import('./components/ApplicationsPage').then(m => m.ApplicationsPage),
    mountPoint: rootRouteRef,
  }),
);
